import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BaseComponent } from '../../base/base.component';
import {
    defaultSharingLinkTypeMapping,
    generateOrgAnonymousLinksSharingPolicySchema,
    initOrgAnonymousLinksSharingPolicyForm,
    oneDriveSharingCapabilityMapping,
    OrgAnonymousLinksSharingPolicySchema,
    SharingCapabilityMapping as sharingCapabilityMapping,
} from '../../../../../../../modules/sway/models/baseline-schemas/org-anonymous-links-sharing-policy';

@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit {
    constructor(private fb: FormBuilder) {
        super();
    }

    oneDriveSharingCapabilityMapping = oneDriveSharingCapabilityMapping;
    defaultSharingLinkTypeMapping = defaultSharingLinkTypeMapping;
    sharingCapabilityMapping = sharingCapabilityMapping;

    ngOnInit(): void {
        const schema: OrgAnonymousLinksSharingPolicySchema = JSON.parse(JSON.stringify(this.baseline.schema));
        this.form = initOrgAnonymousLinksSharingPolicyForm(schema);
        console.log(this.data, 'data');
        console.log(this.baseline, 'baseline');
        console.log(this.errors, 'errors');

        this.form.valueChanges.subscribe((values) => {
            console.log(values);
            const schema = generateOrgAnonymousLinksSharingPolicySchema(values);

            this.baselineChange.next({
                ...this.baseline,
                schema: JSON.parse(JSON.stringify(schema)),
            });
        });
    }

    onSharingCapabilityChange() {
        this.form.get('OneDriveSharingCapability').patchValue(this.formValue.SharingCapability);
        if (this.formValue.SharingCapability == 2) {
            this.form.get('DefaultSharingLinkType').patchValue(this.formValue.SharingCapability);
            this.form.get('FolderAnonymousLinkType').patchValue(1);
            this.form.get('FileAnonymousLinkType').patchValue(1);
        }
    }

    get formValue() {
        return this.form.value;
    }
}
